module.exports = __webpack_public_path__ + "img/female_4.da4839ea.png";